import axios from 'axios'
import UtilService from './UtilService'
import TokenService from './TokenService'

export default class PostService {
  constructor(source, needToken, sistema) {
    this.source = source
    this.util = new UtilService(source)
    this.host = process.env.VUE_APP_URL_BBRAS
    this.axiosClient = axios.create()
    this.needToken = needToken
    this.sistema = sistema;
  }

  addBearer(){
    if (this.needToken) {
      this.tokenService = new TokenService()
      if (!this.sistema) this.sistema = ''
      else this.sistema = ' ' + this.sistema.trim()      
      this.axiosClient.defaults.headers.post['Authorization'] = 'Bearer ' + this.tokenService.TokenSession() + this.sistema
      this.axiosClient.defaults.headers.get['Authorization'] = 'Bearer ' + this.tokenService.TokenSession() + this.sistema
    }
  }

  Post(url, params, callback, callbackErro, hideLoading) {
    this.addBearer();
    let urlPost = url.startsWith('http') ? url : (this.host + url)
    if (!hideLoading) this.util.Loading(true)
    this.axiosClient.post(urlPost, params).then((response) => {
      this.TratarRetorno(response, callback, callbackErro)
    }).catch(erroPost => {
      this.TratarErro(erroPost, callbackErro)
    })
  }

  Get(url, callback, callbackErro, hideLoading) {
    this.addBearer();
    let urlGet = url.startsWith('http') ? url : (this.host + url)
    if (!hideLoading) this.util.Loading(true)

    if (urlGet.indexOf('corporativo/api') > -1) {
      urlGet = urlGet.replace('bbraswebtst02', 'bbraswebtst01')
    }

    this.axiosClient.get(urlGet).then((response) => {
      this.TratarRetorno(response, callback, callbackErro)
    }).catch(erroPost => {
      this.TratarErro(erroPost, callbackErro)
    })
  }

  TratarRetorno(response, callback, callbackErro) {
    this.util.Loading(false)
    if (response.status === 200 && !response.data.HasErrors) {
      if (response.data.Data) {
        callback(response.data.Data)
      }
      else if (response.data.data) {
        callback(response.data.data)
      }
      else if (response.data) {
        callback(response.data)
      }
      else {
        callback(response)
      }
    }
    else {
      this.TratarErro(response, callbackErro)
    }
  }

  TratarErro(response, callbackErro) {
    this.util.Loading(false)
    if (response && (response.status === 401 || (response.response && response.response.status && response.response.status === 401)))
    {
      this.util.RedirectLogin(true)
    } else {
      if (callbackErro)
        callbackErro(response)
      else {
        alert('Erro Request');
        console.log(response);
      }
    }
  }
}
